export function tokenTimeChecker(time: string) {
    if (!time) return false
    const timeStamp = Date.parse(time) + 60 * 1000 * Number(process.env.REACT_APP_REFRESH_TIME) 
    const timeStampNow = Date.parse(new Date().toUTCString());
    const diff = timeStamp - timeStampNow
    if (diff >= 6 * 1000) {
        return true
    } else {
        return false
    }
}
